import { component as defineComponent } from 'flightjs';

import withChildComponents from 'flight-with-child-components';
import WatchButtonUI from 'browse/ui/watch-button';
import ArchiveButtonUI from 'browse/ui/archive-button';
import WorkedTogetherUI from 'browse/ui/worked-together';
import withSpinner from 'app/mixins/with-loading-spinner';
import ListingsPagination from 'browse/ui/listings-pagination';
import initFavoritingButtons from 'browse/apps/favoriting/init-favoriting-buttons';
import '@99designs/common/jquery-plugins/tooltip';
import 'app/modules/datetime';

function contests() {
    this.childTeardownEvent = 'dataContestsLoaded';

    this.attributes({
        listings: '[data-listings]',
        watchButton: '[data-watch-button]',
        workedTogetherIcon: '[data-worked-together-icon]',
        archiveButton: '[data-archive-button]',
        dateTimeItem: '.gmttime',
        paginator: '[data-paginator]',
        clients: '[data-clients]',
        favoriteButton: '[data-favorite-button]',
    });

    this.showContests = function (e, data) {
        // BEFORE
        $('.tooltip').remove();
        this.select('listings').find('[data-tooltip]').remove();

        this.$node.html(data);

        // AFTER
        this.initializeListings();
    };

    this.tooltips = function () {
        $(this.select('listings')).find('[data-tooltip]').tooltip();
    };

    this.initializeListings = function () {
        this.attachChild(WatchButtonUI, this.select('watchButton'));
        this.attachChild(ArchiveButtonUI, this.select('archiveButton'));
        this.attachChild(WorkedTogetherUI, this.select('workedTogetherIcon'));
        this.attachChild(ListingsPagination, this.select('paginator'));
        this.select('dateTimeItem').dateTime();
        this.clientRelationships();
        this.tooltips();
    };

    this.clientRelationships = function () {
        if (this.select('clients').length && this.select('clients').data('clientIds') !== '') {
            this.trigger('uiClientDataRequested', {
                url: this.select('clients').data('clientsUrl'),
                ids: this.select('clients').data('clientIds').toString().split(','),
            });
        }
    };

    this.favoriteButtons = function (e, data) {
        if (this.select('favoriteButton').length) {
            this.select('favoriteButton').each((index, node) => {
                const clientId = node.getAttribute('data-client-id');
                const favoriteUrl = `${node.getAttribute('data-favorite-url')}/${clientId}`;
                const isFavorite = data.favoriteClientIds.includes(parseInt(clientId, 10));
                initFavoritingButtons(node, clientId, favoriteUrl, isFavorite);
            });
        }
    };

    this.after('initialize', function () {
        this.initializeListings();
        this.initializeLoadingSpinner(this.$node);
        this.on(document, this.childTeardownEvent, this.showContests);
        this.on(document, 'dataClientsLoaded', this.favoriteButtons);
    });
}

export default defineComponent(contests, withChildComponents, withSpinner);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/listings-pane.js